import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ThemeToggleComponent } from '../theme-toggle/theme-toggle.component';
import { UiSettingsService } from '../../../shared/services/ui-settings.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-programming-panel',
  standalone: true,
  imports: [CommonModule, FormsModule, ThemeToggleComponent, TranslatePipe],
  templateUrl: './programming-panel.component.html',
  styleUrl: './programming-panel.component.scss'
})
export class ProgrammingPanelComponent {
  public ui = inject(UiSettingsService);

  onFontFamilyChange(event: any): void {
    this.ui.setFontFamily(event.target.value);
  }

  onFontSizeChange(event: any): void {
    this.ui.setFontSize(event.target.value);
  }

  onMaxDisplayMaterialsChange(event: any): void {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value)) {
      this.ui.setMaxDisplayMaterials(value);
    }
  }

  onDayChange(event: any): void {
    this.ui.setTestDay(parseInt(event.target.value));
  }

  onTimeChange(event: any): void {
    const [hours, minutes] = event.target.value.split(':').map(Number);
    this.ui.setTestTimeOfDay(hours, minutes);
  }

  resetToCurrentTime(): void {
    this.ui.resetTestTime();
  }
}